import {
    CreditReviewForm,
    FinanceReviewForm,
    InvestigationReviewDomesticForm,
    InvestigationReviewInternationalForm,
    ManagerReviewForm
} from '../models/cod-review.model';
import { CodAttachment } from '../models/cod-create.model';

export class LoadCodById {
    static readonly type = '[Cod Review] Load Cod';
    constructor(public id: string) {}
}

export class ReassignCod {
    static readonly type = '[Cod Review] Reassign Cod';
    constructor(public id: string, public gid: string) {}
}

export class SubmitCreditReview {
    static readonly type = '[Cod Review] Submit Credit Review';
    constructor(public data: CreditReviewForm) {}
}

export class LoadCreditReview {
    static readonly type = '[Cod Review] Load Credit Review';
    constructor(public id: string) {}
}

export class SubmitInvestigationReviewInternational {
    static readonly type = '[Cod Review] Submit Investigation Review International';
    constructor(public data: InvestigationReviewInternationalForm) {}
}

export class LoadInvestigationReviewInternational {
    static readonly type = '[Cod Review] Load Investigation Review International';
    constructor(public id: string) {}
}

export class SubmitInvestigationReviewDomestic {
    static readonly type = '[Cod Review] Submit Investigation Review Domestic';
    constructor(public data: InvestigationReviewDomesticForm) {}
}

export class LoadInvestigationReviewDomestic {
    static readonly type = '[Cod Review] Load Investigation Review Domestic';
    constructor(public id: string) {}
}

export class SubmitManagerReview {
    static readonly type = '[Cod Review] Submit Manager Review';
    constructor(public data: ManagerReviewForm) {}
}

export class LoadManagerReview {
    static readonly type = '[Cod Review] Load Manager Review';
    constructor(public id: string) {}
}

export class SubmitFinanceReview {
    static readonly type = '[Cod Review] Submit Finance Review';
    constructor(public data: FinanceReviewForm) {}
}

export class LoadFinanceReview {
    static readonly type = '[Cod Review] Load Finance Review';
    constructor(public id: string) {}
}

export class ResetCodReview {
    static readonly type = '[Cod Review] Reset Cod Review';
}

export class DownloadAttachment {
    static readonly type = '[Cod Review] Download Attachment';
    constructor(public key: string) {}
}

export class LoadComments {
    static readonly type = '[Cod Review] Load Comments';
}

export class LazyLoadComments {
    static readonly type = '[Cod Review] Lazy Load Comments';
}

export class AddComment {
    static readonly type = '[Cod Review] Add Comment';
    constructor(public comment: string, public attachments: CodAttachment[] = []) {}
}

export class DeleteComment {
    static readonly type = '[Cod Review] Delete Comment';
    constructor(public id: string) {}
}
